module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agreements) ? _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [_c('div', {
    staticClass: "cb-section cb-guarantee"
  }, [_c('div', {
    staticClass: "cb-note cb-note--left cb-note--align cb-note--fw cb-note--overflow"
  }, [_c('div', {
    staticClass: "cb-note__content"
  }, [_vm._l((_vm.agreements), function(value, key) {
    return [_c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.sanitizeTags(_vm.getAgreement(value))),
        expression: "sanitizeTags(getAgreement(value))"
      }],
      key: key,
      staticClass: "cb-note__p"
    })]
  })], 2)])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e551c10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/payment-methods/direct-debit/GocardlessGuarantee.vue
// module id = 170
// module chunks = 21 83 84 86